// label = pays affiché ; value = nationalité (adjectif) reconnue par le backend ; flag = emoji drapeau
// France est placée en priorité en tête de liste, le reste par ordre alphabétique.
export const NATIONALITIES = [
  { label: "France", value: "Française", flag: "🇫🇷" },
  { label: "Afrique du Sud", value: "Sud-africaine", flag: "🇿🇦" },
  { label: "Algérie", value: "Algérienne", flag: "🇩🇿" },
  { label: "Allemagne", value: "Allemande", flag: "🇩🇪" },
  { label: "Angleterre / Royaume-Uni", value: "Britannique", flag: "🇬🇧" },
  { label: "Argentine", value: "Argentine", flag: "🇦🇷" },
  { label: "Australie", value: "Australienne", flag: "🇦🇺" },
  { label: "Autriche", value: "Autrichienne", flag: "🇦🇹" },
  { label: "Belgique", value: "Belge", flag: "🇧🇪" },
  { label: "Brésil", value: "Brésilienne", flag: "🇧🇷" },
  { label: "Canada", value: "Canadienne", flag: "🇨🇦" },
  { label: "Chine", value: "Chinoise", flag: "🇨🇳" },
  { label: "Corée du Sud", value: "Coréenne", flag: "🇰🇷" },
  { label: "Côte d'Ivoire", value: "Ivoirien", flag: "🇨🇮" },
  { label: "Danemark", value: "Danoise", flag: "🇩🇰" },
  { label: "Égypte", value: "Égyptienne", flag: "🇪🇬" },
  { label: "Espagne", value: "Espagnole", flag: "🇪🇸" },
  { label: "États-Unis", value: "Américaine", flag: "🇺🇸" },
  { label: "Finlande", value: "Finlandaise", flag: "🇫🇮" },
  { label: "Grèce", value: "Grecque", flag: "🇬🇷" },
  { label: "Inde", value: "Indienne", flag: "🇮🇳" },
  { label: "Irlande", value: "Irlandaise", flag: "🇮🇪" },
  { label: "Italie", value: "Italienne", flag: "🇮🇹" },
  { label: "Japon", value: "Japonaise", flag: "🇯🇵" },
  { label: "Maroc", value: "Marocaine", flag: "🇲🇦" },
  { label: "Mexique", value: "Mexicaine", flag: "🇲🇽" },
  { label: "Norvège", value: "Norvégienne", flag: "🇳🇴" },
  { label: "Nouvelle-Zélande", value: "Néo-zélandaise", flag: "🇳🇿" },
  { label: "Pays-Bas", value: "Néerlandaise", flag: "🇳🇱" },
  { label: "Pologne", value: "Polonaise", flag: "🇵🇱" },
  { label: "Portugal", value: "Portugaise", flag: "🇵🇹" },
  { label: "Qatar", value: "Qatari", flag: "🇶🇦" },
  { label: "Russie", value: "Russe", flag: "🇷🇺" },
  { label: "Sénégal", value: "Sénégalaise", flag: "🇸🇳" },
  { label: "Suède", value: "Suédoise", flag: "🇸🇪" },
  { label: "Suisse", value: "Suisse", flag: "🇨🇭" },
  { label: "Tunisie", value: "Tunisienne", flag: "🇹🇳" },
  { label: "Turquie", value: "Turque", flag: "🇹🇷" },
];

// Renvoie l'emoji drapeau correspondant à une nationalité (adjectif) stockée en base, sinon "".
const _byValue = NATIONALITIES.reduce((acc, n) => { acc[n.value] = n.flag; return acc; }, {});
export const flagByNationality = (nationality) => (nationality ? _byValue[nationality] || "" : "");

// Nom du pays traduit dans la langue du site (code ISO déduit de l'emoji drapeau).
export const isoFromFlag = (flag) => [...flag].map((c) => String.fromCharCode(c.codePointAt(0) - 127397)).join("");
export const countryLabel = (n, lang) => {
  try {
    const l = (lang || "fr").replace("_", "-").replace(/^es-mx$/i, "es-MX");
    return new Intl.DisplayNames([l, "fr"], { type: "region" }).of(isoFromFlag(n.flag)) || n.label;
  } catch { return n.label; }
};
